import React, { Component } from "react";
import InputMask from "react-input-mask";

class CadastroEndereco extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">ENDEREÇO</h4>
              <div className="form-group row">
                <div className="col-md-3">
                  <label>Estado</label>
                  <input
                    placeholder="ESTADO"
                    type="text"
                    name="estado"
                    className="form-control"
                    value={this.props.value.estado}
                    onChange={this.props.onChange}
                  />
                </div>
                <div className="col-md-3">
                  <label>Cidade</label>
                  <input
                    placeholder="CIDADE"
                    type="text"
                    name="cidade"
                    className="form-control"
                    value={this.props.value.cidade}
                    onChange={this.props.onChange}
                  />
                </div>
                <div className="col-md-6">
                  <label>Logradouro</label>
                  <input
                    placeholder="LOGRADOURO"
                    type="text"
                    name="logradouro"
                    className="form-control"
                    value={this.props.value.logradouro}
                    onChange={this.props.onChange}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md-3">
                  <label>Número</label>
                  <input
                    placeholder="NÚMERO"
                    type="text"
                    name="numero"
                    className="form-control"
                    value={this.props.value.numero}
                    onChange={this.props.onChange}
                  />
                </div>
                <div className="col-md-3">
                  <label>CEP</label>
                  <InputMask
                    placeholder="CEP"
                    type="text"
                    name="cep"
                    mask="99.999-999"
                    className="form-control"
                    value={this.props.value.cep}
                    onChange={this.props.onChange}
                  />
                </div>
                <div className="col-md-6">
                  <label>Bairro</label>
                  <input
                    placeholder="BAIRRO"
                    type="text"
                    name="bairro"
                    className="form-control"
                    value={this.props.value.bairro}
                    onChange={this.props.onChange}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md-6">
                  <label>Complemento</label>
                  <input
                    placeholder="COMPLEMENTO"
                    type="text"
                    name="complemento"
                    className="form-control"
                    value={this.props.value.complemento}
                    onChange={this.props.onChange}
                  />
                </div>
                <div className="col-md-6">
                  <label>Ponto de Referência</label>
                  <input
                    placeholder="PONTO DE REFERENCIA"
                    type="text"
                    name="pontoReferencia"
                    className="form-control"
                    value={this.props.value.pontoReferencia}
                    onChange={this.props.onChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CadastroEndereco;
